<template>
    <div class="panel panel-default m-t-30">
        <div class="panel-heading separator">
            <div class="panel-title">
                Informations de debug
            </div>
        </div>
        <div class="panel-body">
            <div class="row m-t-10">
                <div class="col-md-6">
                    <ul v-if="isAdmin">
                        <li>
                            <button @click="syncFromSAP"
                                    class="btn btn-info btn-lg btn-rounded btn-animated from-left fa fa-cloud"
                                    type="button">
                                <span v-if="!pending">Synchro Contrats depuis SAP</span>
                                <span v-else>Veuillez patienter...</span>
                            </button>
                        </li>
                    </ul>

                    <ul class="m-l-10">
                        <li>
                            <h5>URL de l'API:</h5>
                            <code>{{API_URL}}</code>
                        </li>
                        <li>
                            <h5>Mode Vue:</h5>
                            <code>{{VueEnvironnement}}</code>
                        </li>
                        <li>
                            <h5>Branche git actuelle:</h5>
                            <code>{{GitCurrentBranch}}</code>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6"
                     v-if="someDataSynced">
                    <h4>Informations sur la synchro contrats</h4>
                    <ul>
                        <li>
                            <h5>Nombre total de contrats:</h5>
                            <code>{{dataSynced.nb_contract}}</code>
                        </li>
                        <li>
                            <h5>Traité(s):</h5>
                            <code>{{dataSynced.nb_treated}}</code>
                        </li>
                        <li>
                            <h5>Non Traité(s):</h5>
                            <code>{{dataSynced.nb_not_treated}}</code>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>


<style scoped>
    .pending {
        text-decoration: underline;
    }
</style>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                pending: false,
                dataSynced: {}
            }
        },

        computed: {
            API_URL () {
                return __API_URL__
            },

            VueEnvironnement () {
                return process.env.NODE_ENV
            },

            GitCurrentBranch () {
                return 'local-dev'
            },

            ...mapGetters([
                'isAdmin'
            ]),

            someDataSynced () {
                return !_.isEmpty(this.dataSynced)
            }
        },

        methods: {
            syncFromSAP () {
                if (this.pending)
                    return;
                this.pending = true
                this.axios.get('synchro_contract', {
                    timeout: 0,
                })
                    .then(response => {
                        this.pending = false
                        this.dataSynced = _.assign({}, response.data)
                        $('body').pgNotification({
                            style: "circle",
                            title: "Synchro Contrats depuis SAP",
                            type: "complete-success",
                            message: "réussie",
                            timeout: 5000
                        }).show()
                    })
                    .catch(error => {
                        this.pending = false
                        this.dataSynced = {}
                        $('body').pgNotification({
                            style: "circle",
                            title: "Synchro Contrats depuis SAP",
                            type: "danger",
                            message: "échouée",
                            timeout: 10000
                        }).show()
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/views/Debug.vue